import {combineReducers} from '@modifi/redux'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {DirectDebitBankAccountView} from '@modifi/onboarding-api-clients'
import collectionReducer from './collection'

export default combineReducers({
  collection: collectionReducer,
})

export type DirectDebitBankAccountState = {
  collection: KeyWindowState<DirectDebitBankAccountView>
}
